<div class="punctuality-filter d-flex flex-row">
    <div class="filter-wrapper d-flex flex-auto text-x-small">
        <mat-checkbox [ngModel]="filterInMap" (change)="setMapFilter($event)">{{'Filter on map' |
            translate}}</mat-checkbox>
    </div>
    <div class="filter-wrapper filter-list clickable d-flex flex-auto align-items-center justify-content-between"
        (click)="toggleStopFilter()">

        @if (filterIsActive) {
            <div matBadgeSize="small" matBadge="1" matBadgeColor="warn" class="text-x-small">{{ 'Filter List' |
                translate }}</div>
        } @else {
            <div class="text-x-small">{{ 'Filter List' | translate }}</div>
        }

        <div class="text-tiny filter-list">
            <i class="icon fas fa-filter"></i>

            <div class="stop-filter-position-wrapper">
                @if (showStopFilter) {
                    <div class="stop-filter-wrapper add-shadow">
                        <mat-radio-group class="d-flex flex-column" aria-labelledby="stop-filter-label"
                            [(ngModel)]="stopFilterValue" (change)="setStopFilter($event)">
                            @for (option of filterStopOptions; track option.value) {
                                <mat-radio-button class="radio-button text-x-small" (click)="$event.stopPropagation()"
                                    [value]="option.value">
                                    {{option.title | translate}}
                                </mat-radio-button>
                            }
                        </mat-radio-group>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

<div class="punctuality-lists">
    <div class="punctuality-list">
        <div class="filter">
            <app-toggle-view>
                <ng-container title><span class="tag mini-tag">
                        <i class="icon fa-solid fa-bus-simple"></i>&nbsp;{{itemsEarly?.length}}</span>{{'Early departures' |
                    translate}} </ng-container>
                <ng-container info>
                    <div> > {{earlyDeviationFilter.minutes | number:'2.0'}}:{{earlyDeviationFilter.seconds|
                        number:'2.0'}}</div>
                </ng-container>
                <ng-template>
                    <app-deviation-filter
                    [showHours]="false"
                    [deviationsFilter]="earlyDeviationFilter"
                    (deviationFilterChanged)="onEarlyDeviationFilterChanged($event)"
                ></app-deviation-filter>
                </ng-template>
            </app-toggle-view>
        </div>
        @if (itemsEarly) {
            @if (itemsEarly.length > 0) {
                <app-compact-list [items]="itemsEarly" [columns]="columnsEarly" (itemSelected)="itemSelected($event)"
                    (columnsUpdated)="columnsUpdated($event)">
                </app-compact-list>
            } @else {
                <app-feedback-text type="empty">
                    {{ 'No deviations matching the filter' | translate }}
                </app-feedback-text>
            }
        } @else {
            <div class="py-4">
                <places-spinner [small]="true"></places-spinner>
            </div>
        }
    </div>

    <div class="punctuality-list">
        <div class="filter">
            <app-toggle-view>
                <ng-container title><span class="tag mini-tag"><i class="icon fa-solid fa-bus-simple"></i>&nbsp;{{itemsLate?.length}}</span>
                    {{'Late departures' | translate}}</ng-container>
                <ng-container info>
                    <div> > {{lateDeviationFilter.minutes| number:'2.0'}}:{{lateDeviationFilter.seconds|
                        number:'2.0'}}</div>
                </ng-container>
                <ng-template>
                    <app-deviation-filter
                    [showHours]="false"
                    [deviationsFilter]="lateDeviationFilter"
                    (deviationFilterChanged)="onLateDeviationFilterChanged($event)"
                ></app-deviation-filter>
                </ng-template>
            </app-toggle-view>
        </div>
        @if (itemsLate) {
            @if (itemsLate.length > 0) {
                <app-compact-list [items]="itemsLate" [columns]="columnsLate" (itemSelected)="itemSelected($event)"
                    (columnsUpdated)="columnsUpdated($event)">
                </app-compact-list>
            } @else {
                <app-feedback-text type="empty">
                    {{ 'No deviations matching the filter' | translate }}
                </app-feedback-text>
            }
        } @else {
            <div class="py-4">
                <places-spinner [small]="true"></places-spinner>
            </div>
        }
    </div>
</div>
